import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, map, switchMap } from 'rxjs';
import {
  ChopAlterskategorie,
  ChopKatalog,
  ChopLeistungsgruppe,
  ChopMassnahme,
  ChopMesskriterium,
  ChopMesskriteriumMassnahmenRegel,
  ChopProfil,
  ChopProfilMassnahme,
} from '@entity/chop';
import { ChopService } from '@service/chop.service';

export interface ChopMesskriteriumDetailData {
  messkriterium: ChopMesskriterium;
  profil: ChopProfil;
  leistungsgruppe: ChopLeistungsgruppe;
  alterskategorie: ChopAlterskategorie;
  katalog: ChopKatalog;
  regeln: ChopMesskriteriumMassnahmenRegel[];
  allMassnahmen: ChopMassnahme[];
  profilMassnahmen: ChopProfilMassnahme[];
}

export const ChopMesskriteriumDetailResolve: ResolveFn<ChopMesskriteriumDetailData> = (route) => {
  const chopService = inject(ChopService);
  return chopService.getMesskriterium(+route.params.messkriteriumId).pipe(
    switchMap((messkriterium) =>
      forkJoin({
        profil: chopService.getProfil(messkriterium.chopProfilId),
        regeln: chopService.getRegeln(messkriterium.id),
        profilMassnahmen: chopService.getProfilMassnahmen(messkriterium.chopProfilId),
      }).pipe(
        switchMap((rest) =>
          chopService
            .getLeistungsgruppe(rest.profil.chopLeistungsgruppeId)
            .pipe(map((leistungsgruppe) => ({ ...rest, leistungsgruppe })))
        ),
        switchMap((rest) =>
          chopService
            .getAlterskategorie(rest.leistungsgruppe.chopAlterskategorieId)
            .pipe(map((alterskategorie) => ({ ...rest, alterskategorie })))
        ),
        switchMap((rest) =>
          chopService
            .getKatalog(rest.alterskategorie.chopKatalogId)
            .pipe(map((katalog) => ({ messkriterium, ...rest, katalog })))
        ),
        switchMap((rest) =>
          chopService.getMassnahmen(rest.katalog.jahr).pipe(map((allMassnahmen) => ({ ...rest, allMassnahmen })))
        )
      )
    )
  );
};
